/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .form-component.sidebar-panel {
    > .card {
      border-width: 0;
    }
    .form-group {
      margin-bottom: 8px;

      > .control-label {
        font-size: 0.9rem;
      }

      > fieldset {
        display: flex;
        flex-direction: column;
      }

      > fieldset > legend[id^='root_'][id$='__title'] {
        font-size: 0.9rem;
        background-color: transparent;
        color: inherit;
      }

      &.field.field-object {
        > .row,
        > fieldset > .row {
          margin-left: 0;
          margin-right: 0;
        }

        &.fieldset > fieldset {
          border-radius: 10px;
          border: 1px dotted gray;

          .field {
            padding: 0 8px;
          }

          .field:hover {
            background-color: ${$.gray100};
          }

          > legend {
            padding-left: 4px;
            padding-right: 4px;
            text-align: center;
            background-color: transparent;
            width: auto;
          }
        }
      }

      + .form-group.separator::before {
        display: block;
        content: ' ';
        margin-left: -8px;
        margin-right: -8px;
        border-top: 1px solid black;
        padding: 8px;
      }
    }
  }
`;
